import { i18n } from 'i18n';

export const ROUTE_PATH = '/details';
export const TITLE = i18n._('Dashboard');
